import { connect } from "react-redux";

import Pap from "../../components/Pap/Pap";
import { getCaseById, getContactById } from "../../selectors/case";
import { setShowAcceptPapModal, setShowRejectPapModal } from "../../actions/modal";

const MapStateToProps = (state, ownProps) => {
	const cas = getCaseById(state.cases.listCasesWithManager, ownProps.id);
	const contact = getContactById(state.cases.listContacts, ownProps.id);
	return { cas, contact };
};

const MapDispatchToProps = (dispatch) => ({
	setShowAcceptPapModal: (bool) => {dispatch(setShowAcceptPapModal(bool));},
	setShowRejectPapModal: (bool) => {dispatch(setShowRejectPapModal(bool));},
});

export default connect(MapStateToProps, MapDispatchToProps)(Pap);